export function validateIbanCheckNew(input) {
  var CODE_LENGTHS = {
    DE: 22,
  };

  const iban = String(input)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  const match = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
  if (!match) return false;

  const [_, countryCode] = match;
  if (iban.length !== CODE_LENGTHS[countryCode]) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const converted = rearranged.replace(
    /[A-Z]/g,
    (char) => char.charCodeAt(0) - 55
  );

  let remainder = converted;
  while (remainder.length > 2) {
    const block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
  }

  return parseInt(remainder, 10) % 97 === 1;
}
